import { PriceInput } from "components/PriceInput/PriceInput";
import { Textbox } from "components/Textbox/Textbox";
import { UnitDictionary } from "pages/InventoryAndSales/Inventory/BaseDefinitionAndSetting/Unit/components/UnitDictionary";
import React, { useEffect, useState } from "react";
import { RoundWithRoundingPlace } from "utils/helpers";

interface Props {
  mode: "view" | "edit";
  resetForm: any;
  setUserChanges: (e: any) => void;
  numberOfSalesUnit: number;
  priceList: any;
  priceListDetail: any[];
  currency: any;
  rate: any;
  Constraint: any;
  detailPriceData: any;
  setRate: (e: any) => void;
  setPriceListDetail: (e: any) => void;
  updateQuantity: (e: any, list?: any, type?: any) => void;
  setDictionaryName: (e: any) => void;
  MasterUnitPriceRoundingPlace?:any
}

const PriceFields: React.FC<Props> = ({
  mode,
  resetForm,
  setUserChanges,
  numberOfSalesUnit,
  priceList,
  priceListDetail,
  currency,
  rate,
  Constraint,
  detailPriceData,
  setRate,
  setPriceListDetail,
  updateQuantity,
  setDictionaryName,
  MasterUnitPriceRoundingPlace
}) => {
  const [qty, setQty] = useState({
    qty1: detailPriceData.Qty1,
    qty2: detailPriceData.Qty2,
  });

  const handleQuantityChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    qtyType: "Qty1" | "Qty2"
  ) => {
    const value = +e.target.value;
    if (
      (numberOfSalesUnit === (qtyType === "Qty1" ? 1 : 2) ||
        (!detailPriceData.IsAbsoluteUnitConversionRatio &&
          detailPriceData.IsAbsoluteUnitConversionRatio != null)) &&
      value >= +e.target.min &&
      (e.target.max ? value <= +e.target.max : true)
    ) {
      if (
        !detailPriceData.IsAbsoluteUnitConversionRatio &&
        detailPriceData.IsAbsoluteUnitConversionRatio != null
      ) {
        setRate(
          (qtyType === "Qty1" ? value : qty.qty1) /
            (qtyType === "Qty1" ? qty.qty2 : value)
        );
      }
      updateQuantity(
        value,
        [],
        !detailPriceData.IsAbsoluteUnitConversionRatio &&
          detailPriceData.IsAbsoluteUnitConversionRatio != null
          ? qtyType
          : null
      );
    }
  };

  const handleUnitPriceChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    qtyType: "Qty1" | "Qty2"
  ) => {
    const value = +e.target.value.replaceAll(",", "");
    if (qtyType === "Qty1") {
      if (numberOfSalesUnit == 1) {
        setPriceListDetail((pre) => {
          return [
            {
              ...pre[0],
              SalesUnitPrice: +e.target.value.replaceAll(",", ""),
              UnitPrice: +e.target.value.replaceAll(",", "") * rate,
            },
          ];
        });
      } else {
        setPriceListDetail((pre) => {
          return [
            {
              ...pre[0],
              SalesUnitPrice: +e.target.value.replaceAll(",", "") / rate,
              UnitPrice: +e.target.value.replaceAll(",", ""),
            },
          ];
        });
      }
    } else {
      if (numberOfSalesUnit == 2) {
        setPriceListDetail((pre) => {
          return [
            {
              ...pre[0],
              SalesUnitPrice: +e.target.value.replaceAll(",", ""),
              UnitPrice: +e.target.value.replaceAll(",", "") / rate,
            },
          ];
        });
      } else {
        setPriceListDetail((pre) => {
          return [
            {
              ...pre[0],
              SalesUnitPrice: +e.target.value.replaceAll(",", "") * rate,
              UnitPrice: +e.target.value.replaceAll(",", ""),
            },
          ];
        });
      }
    }
  };
  useEffect(() => {
    setQty({ qty1: detailPriceData.Qty1, qty2: detailPriceData.Qty2 });
  }, [detailPriceData]);

  return (
    <>
      <div className="row">
        <div className="col-lg-3 col-11">
          <Textbox
            Change={setUserChanges}
            textboxName="Qty1"
            textboxType="number"
            labelText="Qty1"
            customClass={"arrow-none"}
            readonly={
              numberOfSalesUnit != 1 &&
              detailPriceData.IsAbsoluteUnitConversionRatio &&
              detailPriceData.IsAbsoluteUnitConversionRatio != null
            }
            step={10 ** detailPriceData.Qty1RoundingPlace}
            value={
              detailPriceData.Qty1
                ? detailPriceData.Qty1
                : detailPriceData.Qty1 == 0
                ? "0"
                : "1"
            }
            defaultValue={
              detailPriceData.Qty1
                ? detailPriceData.Qty1
                : detailPriceData.Qty1 == 0
                ? "0"
                : "1"
            }
            usePrevDefaultValue={
              priceList.HasDetailRange &&
              numberOfSalesUnit == 1 &&
              priceListDetail[priceListDetail.length - 1]
                ?.[
                  numberOfSalesUnit === 1
                    ? "SalesUnitMinOrderQty"
                    : "MinOrderQty"
                ]=== detailPriceData.Qty1
            }
            min={
              priceListDetail.length > 0
                ? priceListDetail[0][
                    numberOfSalesUnit === 1
                      ? "SalesUnitMinOrderQty"
                      : "MinOrderQty"
                  ] || 10 ** detailPriceData.Qty1RoundingPlace
                : 10 ** detailPriceData.Qty1RoundingPlace
            }
            max={
              priceListDetail.length > 0
                ? priceListDetail[priceListDetail.length - 1]
                    ?.MaxOrderQty == null
                  ? undefined
                  : 
                      priceListDetail[priceListDetail.length - 1]?.[
                        numberOfSalesUnit == 1
                          ? "SalesUnitMaxOrderQty"
                          : "MaxOrderQty"
                      ]      
                : undefined
            }
            resetForm={resetForm}
            mode={mode}
            required={true}
            onChange={(e) => handleQuantityChange(e, "Qty1")}
          />
        </div>
        <div className="col-lg-3 col-11">
          <UnitDictionary
            returnObj
            Change={setUserChanges}
            value={detailPriceData?.Unit1Id}
            label="Unit1"
            name="Unit1Id"
            required={false}
            mode={"view"}
            resetForm={resetForm}
            setUnitDictionary={(e) => {
              setDictionaryName((pre) => {
                return { ...pre, Unit1: e.Value };
              });
            }}
          />
        </div>
        <div className="col-lg-3 col-11">
          {/* <Textbox
            Change={setUserChanges}
            textboxName={
              numberOfSalesUnit == 1 ? "SalesUnitPrice" : "Unit1Price"
            }
            textboxType="text"
            labelText="UnitPrice"
            decimals={currency.PriceRoundingPlace}
            defaultValue={
              detailPriceData?.[
                numberOfSalesUnit == 1 ? "SalesUnitPrice" : "UnitPrice"
              ]
            }
            value={
              detailPriceData?.[
                numberOfSalesUnit == 1 ? "SalesUnitPrice" : "UnitPrice"
              ]
            }
            resetForm={resetForm}
            mode={priceList.IsManual && mode != "view" ? "create" : "view"}
            useGroupingPrice={true}
            onChange={(e) => handleUnitPriceChange(e, "Qty1")}
            required={false}
          /> */}
          <PriceInput
                      Change={setUserChanges}
                      CallForPriceText={Constraint?.ItemNoPriceText}
                      useCallForPrice={  detailPriceData?.[
                numberOfSalesUnit == 1 ? "SalesUnitPrice" : "UnitPrice"
              ]==-1?true:false}
            name={
              numberOfSalesUnit == 1 ? "SalesUnitPrice" : "Unit1Price"
            }
            label="UnitPrice"
            decimals={MasterUnitPriceRoundingPlace}
            defaultValue={
              detailPriceData?.[
                numberOfSalesUnit == 1 ? "SalesUnitPrice" : "UnitPrice"
              ]
            }
            value={
              detailPriceData?.[
                numberOfSalesUnit == 1 ? "SalesUnitPrice" : "UnitPrice"
              ]
            }
            resetForm={resetForm}
            mode={priceList.IsManual && mode != "view" ? "create" : "view"}
            onChange={(e) => handleUnitPriceChange(e, "Qty1")}
            required={false}
          />
        </div>
        <div className="col-lg-3 col-11">
          {numberOfSalesUnit == 1 && (
            // <Textbox
            //   Change={setUserChanges}
            //   textboxName="SubTotalPrice"
            //   textboxType="text"
            //   labelText="مبلغ"
            //   value={detailPriceData?.SubTotalPrice}
            //   decimals={currency.PriceRoundingPlace}
            //   round={false}
            //   defaultValue={detailPriceData?.SubTotalPrice}
            //   resetForm={resetForm}
            //   mode={priceList.IsManual && mode != "view" ? "create" : "view"}
            //   useGroupingPrice={true}
            //   required={false}
            // />
            <PriceInput
              Change={setUserChanges}
              name="SubTotalPrice"
              label="مبلغ"
              value={detailPriceData?.SubTotalPrice}
              decimals={MasterUnitPriceRoundingPlace}
              round={false}
              defaultValue={detailPriceData?.SubTotalPrice}
              resetForm={resetForm}
              mode={ "view"}
              required={false}
            />
          )}
        </div>

        {detailPriceData?.Unit2Id ? (
          <>
            <div className="col-lg-3 col-11">
              <Textbox
                Change={setUserChanges}
                textboxName="Qty2"
                textboxType="number"
                labelText="Qty2"
                readonly={
                  numberOfSalesUnit !== 2 &&
                  detailPriceData.IsAbsoluteUnitConversionRatio &&
                  detailPriceData.IsAbsoluteUnitConversionRatio != null
                }
                customClass={"arrow-none"}
            step={10 ** detailPriceData.Qty2RoundingPlace}
                defaultValue={
                  detailPriceData.Qty2
                    ? detailPriceData.Qty2
                    : detailPriceData.Qty2 == 0
                    ? "0"
                    : "1"
                }
                decimals={detailPriceData.Qty2RoundingPlace}
                value={
                  detailPriceData.Qty2
                    ? detailPriceData.Qty2
                    : detailPriceData.Qty2 == 0
                    ? "0"
                    : "1"
                }
                min={
                  priceListDetail.length > 0
                    ? priceListDetail[0][
                        numberOfSalesUnit === 2
                          ? "SalesUnitMinOrderQty"
                          : "MinOrderQty"
                      ] || 10 ** detailPriceData.Qty2RoundingPlace
                    : 10 ** detailPriceData.Qty2RoundingPlace
                }
                max={
                  priceListDetail.length > 0
                    ? priceListDetail[priceListDetail.length - 1]
                        ?.MaxOrderQty == null
                      ? undefined
                      : 
                          priceListDetail[priceListDetail.length - 1]?.[
                            numberOfSalesUnit == 2
                              ? "SalesUnitMaxOrderQty"
                              : "MaxOrderQty"
                          ]
                        
                    : undefined
                }
                usePrevDefaultValue={
                  priceList.HasDetailRange &&
                  numberOfSalesUnit == 2 &&
                  priceListDetail[priceListDetail.length - 1]
                    ?.SalesUnitMaxOrderQty === detailPriceData.Qty2
                }
                resetForm={resetForm}
                mode={mode}
                required={false}
                onChange={(e) => {
                  handleQuantityChange(e, "Qty2");
                }}
              />
            </div>
            <div className="col-lg-3 col-11">
              <UnitDictionary
                returnObj
                Change={setUserChanges}
                value={detailPriceData?.Unit2Id}
                label="Unit2"
                name="Unit2Id"
                required={false}
                mode={"view"}
                resetForm={resetForm}
                setUnitDictionary={(e) =>
                  setDictionaryName((pre) => {
                    return { ...pre, Unit2: e.Value };
                  })
                }
              />
            </div>
            <div className="col-lg-3 col-11">
              {/* <Textbox
                Change={setUserChanges}
                textboxName={
                  numberOfSalesUnit == 2 ? "SalesUnitPrice" : "Unit2Price"
                }
                textboxType="text"
                labelText="UnitPrice"
                value={
                  detailPriceData?.[
                    numberOfSalesUnit == 2 ? "SalesUnitPrice" : "UnitPrice"
                  ]
                }
                decimals={currency.PriceRoundingPlace}
                defaultValue={
                  detailPriceData?.[
                    numberOfSalesUnit == 2 ? "SalesUnitPrice" : "UnitPrice"
                  ]
                }
                resetForm={resetForm}
                mode={priceList.IsManual && mode != "view" ? "create" : "view"}
                useGroupingPrice={true}
                onChange={(e) => handleUnitPriceChange(e, "Qty2")}
                required={false}
              /> */}
              <PriceInput
                   Change={setUserChanges}
                name={
                  numberOfSalesUnit == 2 ? "SalesUnitPrice" : "Unit2Price"
                }
                label="UnitPrice"
                value={
                  detailPriceData?.[
                    numberOfSalesUnit == 2 ? "SalesUnitPrice" : "UnitPrice"
                  ]
                }
                useCallForPrice={detailPriceData?.[
                    numberOfSalesUnit == 2 ? "SalesUnitPrice" : "UnitPrice"
                  ]?true:false}
CallForPriceText={Constraint?.ItemNoPriceText}
                decimals={MasterUnitPriceRoundingPlace}
                defaultValue={
                  detailPriceData?.[
                    numberOfSalesUnit == 2 ? "SalesUnitPrice" : "UnitPrice"
                  ]
                }
                resetForm={resetForm}
                mode={priceList.IsManual && mode != "view" ? "create" : "view"}
                onChange={(e) => handleUnitPriceChange(e, "Qty2")}
                required={false}
              />
            </div>
            {numberOfSalesUnit == 2 && (
              <div className="col-lg-3 col-11">
                {/* <Textbox
                  Change={setUserChanges}
                  textboxName="SubTotalPrice"
                  textboxType="text"
                  labelText="مبلغ"
                  value={detailPriceData?.SubTotalPrice}
                  decimals={currency.PriceRoundingPlace}
                  round={false}
                  defaultValue={detailPriceData?.SubTotalPrice}
                  resetForm={resetForm}
                  mode={
                    priceList.IsManual && mode != "view" ? "create" : "view"
                  }
                  useGroupingPrice={true}
                  required={false}
                /> */}
                <PriceInput
                        Change={setUserChanges}
                  name="SubTotalPrice"
                  label="مبلغ"
                  value={detailPriceData?.SubTotalPrice}
                  decimals={currency.PriceRoundingPlace}
                  round={false}
                  defaultValue={detailPriceData?.SubTotalPrice}
                  resetForm={resetForm}
                  mode={
                     "view" 
                  }
                  required={false}
                />
              </div>
            )}
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default PriceFields;
